<opac-dialog [size]="'full'" [open]="isOpen()" (closed)="closeDialog()">
  <div class="header" slot="header">
    <opac-button
      class="close-button"
      (click)="closeDialog()"
      [ariaLabel]="'common.back' | translate"
      [opacTooltip]="'common.back' | translate">
      <opac-icon slot="only-icon" icon="navigate_back"></opac-icon>
    </opac-button>

    <span>{{externalVideoData()?.title}}</span>

    <opac-button
      *ngIf="externalVideoData()?.contentType !== 'youtube' && fullscreen.fullscreenEnabled"
      class="fullscreen"
      (click)="toggleFullscreen()"
      [ariaLabel]="fullscreenLabel() | translate"
      [opacTooltip]="fullscreenLabel() | translate">
      <opac-icon slot="only-icon" [icon]="fullscreenIcon()"></opac-icon>
    </opac-button>
  </div>

  <div
    *ngIf="externalVideoData()?.contentType !== 'html'"
    [innerHTML]="externalVideoData()?.link | safe"
    [class.is-podcast]="externalVideoData()?.contentType === 'podcast'"
    [class.is-youtube]="externalVideoData()?.contentType === 'youtube'"></div>
  <iframe
    *ngIf="externalVideoData()?.contentType === 'html'"
    class="is-html"
    [src]="externalVideoData()?.link"></iframe>
</opac-dialog>
